<div id="divMerchantAccountInfo"> 
  <div style="width: 100%">
    <div style="display: flex; align-items: start; gap: 10px; justify-content: space-between;">
      @if (this.data.brandName == 'New Brand') {
        <app-button-input
          [title]="'Show Brand List'"
          [text]="'Show Brand List'"
          (click)="showBrandList()"
          [hidden]="this.mode != FormMode.Edit"
        ></app-button-input>
      }
      <div [hidden]="this.hideTitle">
        <h2 class="cpo-section-title">Business Details</h2>
      </div>
      @if (this.enableEditing) {
        <div [hidden]="this.mode != FormMode.View">
          <span class="cpo-edit-link" (click)="btnEdit_click()">Edit</span>
        </div>
      }
  
    </div>
  </div>

  @if (this.mode == FormMode.View) {
    <div style="display: flex; align-items: stretch; justify-content: space-between; flex-wrap: wrap; padding: 0px 0px 0px 30px;">
      <div style="flex: 1;">
        @if (this.data.brandName != 'N/A') {
          <div class="cpo-pod">
            <span class="title">Brand</span>
            <span class="r1">{{ this.data.brandName }}</span>
          </div>
        }
        <div class="cpo-pod">
          <span class="title">Legal Name</span>
          <span class="r1">{{ this.data.legalName }}</span>
        </div>
        <div class="cpo-pod">
          <span class="title">DBA</span>
          <span class="r1">{{ this.data.DBA }}</span>
        </div>
        <div class="cpo-pod">
          <span class="title">EIN/Tax ID</span>
          <span class="r1">{{ this.data.EIN }}</span>
        </div>
      </div>
      <div style="flex: 1;">
        <div class="cpo-pod">
          <span class="title">Business Description</span>
          <span class="r1">{{ this.data.businessDescription }}</span>
        </div>
        <div class="cpo-pod">
          <span class="title">Commodity Code</span>
          <span class="r1">{{ this.data.commodityCode }}</span>
        </div>
        <div class="cpo-pod">
          <span class="title">MCC</span>
          <span class="r1">{{ this.data.MCC }}</span>
        </div>
        @if (this.data.MCCDescription) {
          <div class="cpo-pod">
            <span class="title">MCC Description</span>
            <span class="r1">{{ this.data.MCCDescription }}</span>
          </div>
        }
      </div>
      <div style="flex: 1;">
        <div class="cpo-pod">
          <span class="title">Live Since</span>
          <span class="r1">{{ this.data.createdOn?.toLocaleDateString ? this.data.createdOn.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : this.data.createdOn }}</span>
        </div>
        <div class="cpo-pod">
          <span class="title">DBA Address</span>
          <span class="r1" style="padding-bottom: 4px;">{{ this.data.streetAddress.street1 }}</span>
          @if (this.data.streetAddress.street2) {
            <span class="r1" style="padding-bottom: 4px;">{{ this.data.streetAddress.street2 }}</span>
          }
          <span class="r1" style="padding-bottom: 4px;">{{ this.data.streetAddress.city }}, {{ this.data.streetAddress.state }} {{ this.data.streetAddress.postalCode }}</span>
          <span class="r1" style="padding-bottom: 4px;">{{ this.data.streetAddress.country }}</span>
        </div>
      </div>
    </div>
  } @else {
    <div class="cpo-section-form">
      <div style="display: flex; align-items: start; gap: 40px;">
        <div style="flex: 1">
          @if (this.data.brandName != 'New Brand') {
            <div>
              <app-selectbox
                [label]="'Brand'"
                [type]="ddlModes.Brands"
                [required]="false"
                [(ngModel)]="this.data.brandName"
                [readonly]="this.mode == FormMode.View"
                [options]="brandOptions"
                (onChanged)="brandSelected($event)"
              ></app-selectbox>
            </div>
          }
          @if (this.data.brandName == 'New Brand') {
            <div>
              <app-textbox
                [label]="'New Brand'"
                [required]="true"
                [showRequired]="true"
                [(ngModel)]="this.newBrandName"
                [readonly]="this.mode == FormMode.View"
              ></app-textbox>
            </div>
          }
          <div>
            <app-textbox 
              [label]="'Legal Name'"
              [required]="true"
              [showRequired]="true"
              [(ngModel)]="this.data.legalName"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
          </div>
          <div>
            <app-selectbox
              [label]="'Business Type'"
              [type]="ddlModes.BusinessTypes"
              [required]="false"
              [(ngModel)]="this.data.businessType"
              [readonly]="this.mode == FormMode.View"
              [options]="businessTypeOptions"
              (onChanged)="businessTypeSelected($event)"
            ></app-selectbox>
          </div>
          <div>
            <app-textbox
              [label]="'DBA'"
              [required]="true"
              [showRequired]="true"
              [(ngModel)]="this.data.DBA"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
          </div>
          <div>
            <app-textbox
              [label]="'EIN/Tax ID'"
              [required]="true"
              [helpText]="'format: 12-3456789'"
              [type]="inputTextModes.TaxId"
              [(ngModel)]="this.data.EIN"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
          </div>
          <div>
            <app-textbox
              [label]="'Business Description'"
              [required]="false"
              [(ngModel)]="this.data.businessDescription"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
          </div>
          <div>
            <app-textbox
              [label]="'Commodity Code'"
              [type]="inputTextModes.CommodityCode"
              [helpText]="'8 to 10 digit numeric code'"
              [(ngModel)]="this.data.commodityCode"
              [required]="true"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
          </div>
          <div>
            <app-textbox
              [label]="'MCC'"
              [type]="inputTextModes.MCC"
              [helpText]="'4 digit numeric code'"
              [(ngModel)]="this.data.MCC"
              [required]="false"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
          </div>
          <!-- <div>
            <app-textbox
              [label]="'MCC Description'"
              [(ngModel)]="this.data.MCCDescription"
              [required]="false"
              [readonly]="true"
            ></app-textbox>
          </div>
          <div>
            <app-textbox
              [label]="'Live since'"
              [required]="false"
              [(ngModel)]="data.createdOn"
              [readonly]="true"
            ></app-textbox>
          </div> -->
        </div>
        <div style="flex: 1">
          <div>
            @if (this.data.streetAddress != null) {
              <app-street-address
                #streetAddressForm
                [addressLabel]="'DBA address'"
                [showRequired]="true"
                [streetAddress]="this.data.streetAddress"
                [enableEditing]="this.enableEditing"
                [readonly]="this.mode == FormMode.View"
              ></app-street-address>
            }
          </div>
          <div>
            <app-textbox
              [label]="'Website'"
              [helpText]="'format: https://www.example.com'"
              [required]="true"
              [showRequired]="true"
              [type]="inputTextModes.Website"
              [(ngModel)]="this.data.website"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
          </div>
          <div>
            <app-textbox
              [label]="'Phone'"
              [required]="true"
              [showRequired]="true"
              [type]="inputTextModes.Phone"
              [(ngModel)]="this.data.phone"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
            <app-textbox
              [label]="'Fax'"
              [type]="inputTextModes.Phone"
              [(ngModel)]="this.data.fax"
              [readonly]="this.mode == FormMode.View"
            ></app-textbox>
            <app-selectbox
              [label]="'Timezone'"
              [type]="ddlModes.TimeZones"
              [required]="true"
              [(ngModel)]="this.data.timezone"
              [options]="timezoneOptions"
              [readonly]="this.mode == FormMode.View"
            ></app-selectbox>
          </div>
          <div
            style="display: flex; align-items: center; gap: 10px; margin-top: 10px;"
            [hidden]="this.mode == FormMode.View"
          >
            <app-checkbox
              [label]="'Enable API Integration'"
              [(ngModel)]="this.data.integrationEnabled"
              [disabled]="this.mode == FormMode.View"
            ></app-checkbox>
          </div>
        </div>
      </div>
      @if (this.enableEditing) {
        <div style="display: flex; gap: 20px; justify-content: center; padding: 20px 0px 0px 0px;">
          <button class="btn-secondary" style="width: 150px;" (click)="this.btnCancelClick()"> Cancel </button>
          <button class="btn-primary" style="width: 150px;" (click)="this.btnSaveClick()"> Save </button>
        </div>
      }
    </div>
  }

</div>



